import { render } from "./App.vue?vue&type=template&id=2ed8c768"
const script = {}

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__